// Types
import type {
  IImportErrorFormatter,
  TImportFormattedError,
  TImportValidationError,
} from '~/shared/import/types';

export class ImportValidationErrorFormatter implements IImportErrorFormatter {
  public process(errors: TImportValidationError[]): TImportFormattedError[] {
    return errors.map((error: TImportValidationError) => {
      const title = `Row ${error.row_num}`;
      const items = [`Raw Data: ${error.row_raw_data}`, `Error: ${error.error}`];

      return { title, items };
    });
  }
}
